// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetFeishuSessionsMsgTodayQuery,
    BaseResponseListFeishuMsgFoundResponse,
} from '../../../types';

/**
 * 今日会话消息
 *
 * @export
 * @tags feishu-session-controller
 * @link [GET] /feishuSessions/msg/today
 */
export function getFeishuSessionsMsgToday(
    options: ApiOptions<never, GetFeishuSessionsMsgTodayQuery> & {
        params: GetFeishuSessionsMsgTodayQuery;
    }
): Promise<BaseResponseListFeishuMsgFoundResponse> {
    return request<never, never, GetFeishuSessionsMsgTodayQuery>('/feishuSessions/msg/today', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuSessionsMsgToday',
    });
}

export const meta = [
    { tags: ['feishu-session-controller'], path: '/feishuSessions/msg/today', method: 'get' },
];
